import React, { useReducer } from "react";

// The Reducer ---------------------------------------------------------------------------------------------------------

const initialState = {
  loadedAds: false,
};

const initState = () => {
  return { ...initialState };
};

// Action
//  type = "set", "clear"
//  payload = { index, test, tests }
const reducer = (state, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case "set": {
      let newState = { ...state };
      newState.loadedAds = true;
      return newState;
    }
    case "clear": {
      let newState = initState();
      return newState;
    }
    default:
      return state;
  }
};

// The Context ---------------------------------------------------------------------------------------------------------

export const ApplicationStateContext = React.createContext();

/** The Context Provider.
 *
 *  @param {} props
 */
export const ApplicationStateContextProvider = (props) => {
  const [applicationState, applicationStateDispatch] = useReducer(reducer, initialState);
  return (
    <ApplicationStateContext.Provider value={{ applicationState, applicationStateDispatch }}>
      {props.children}
    </ApplicationStateContext.Provider>
  );
};
